var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.16,
    height: 75.779,
    viewBox: "0 0 18.16 75.779"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a-big {\n        fill: none;\n        stroke: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3235.49 -273.703) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.703 3218.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-big",
    d: "M-9.479-166.394l12.612-8.161-12.612-8.161Z",
    transform: "translate(71.726 182.716)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a-big",
    x2: 62.359,
    transform: "translate(0 7.781)"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMTguMTYiCiAgaGVpZ2h0PSI3NS43NzkiCiAgdmlld0JveD0iMCAwIDE4LjE2IDc1Ljc3OSIKPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuYS1iaWcgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjM1LjQ5IC0yNzMuNzAzKSByb3RhdGUoOTApIj4KICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI3My43MDMgMzIxOC4yNSkiPgogICAgICA8cGF0aAogICAgICAgIGNsYXNzPSJhLWJpZyIKICAgICAgICBkPSJNLTkuNDc5LTE2Ni4zOTRsMTIuNjEyLTguMTYxLTEyLjYxMi04LjE2MVoiCiAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzEuNzI2IDE4Mi43MTYpIgogICAgICAvPgogICAgICA8bGluZSBjbGFzcz0iYS1iaWciIHgyPSI2Mi4zNTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNy43ODEpIiAvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgArrowDownBig as ReactComponent };